/**
 * Kleur van een type-tegel in een paneel (Typepalet, Concepten-lijst).
 *
 * De tegels nemen de notatiekleur van het canvas over, zodat een type er in
 * beide panelen hetzelfde uitziet. Tekenelementen hebben in de notatie een
 * transparante vulling (op het canvas mogen ze niets afdekken) met donkere
 * tekst; in een donker paneel wordt die tekst dan onleesbaar. Bij een
 * transparante vulling krijgt de tegel daarom de achtergrond en tekstkleur van
 * het paneel en houdt alleen de randkleur uit de notatie. Het canvas zelf
 * verandert niet.
 */
import type { CSSProperties } from "react";

export function panelSwatch(colors: { bg: string; border: string; text: string }): {
  style: CSSProperties;
  className: string;
} {
  const transparent = !colors.bg || colors.bg === "transparent" || colors.bg === "none";
  return transparent
    ? { style: { borderColor: colors.border }, className: "bg-(--ld-surface) text-(--ld-text)" }
    : {
        style: { backgroundColor: colors.bg, borderColor: colors.border, color: colors.text },
        className: "",
      };
}
